
export default {

    "e-mail" : "e-mail",
    "password" : "mot de passe",
    "wrong_email_password" : "e-mail ou mot de passe incorrect",
    "login" : "Connexion"

};